import React from 'react';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';
import { ExportAssignmentsButton } from 'works/components/export-team-button';
import { AppContent } from '@common/components';
import { StaffingRequestAssignmentsTable } from 'works/components/staffing-request-assignments-table';
import { ExportTeamButtonContextProvider } from 'works/components/export-team-button/export-team-button-context';
import { Row, Col } from 'antd';

export function SupplierTeamPage() {
  setBreadcrumbs([
    { name: 'Team', path: '/works/supplier/team' },
    { name: 'Assignments', path: '/works/supplier/team' },
  ]);

  return (
    <AppContent>
      <ExportTeamButtonContextProvider>
        <Row>
          <Col span={24} style={{ textAlign: 'right' }}>
            <ExportAssignmentsButton
              filterKey="SupplierTeamTable"
              requestTypes={['on_demand', 'long_term']}
            />
          </Col>
        </Row>
        <StaffingRequestAssignmentsTable />
      </ExportTeamButtonContextProvider>
    </AppContent>
  );
}
